import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Home } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white pt-24">
      <div className="text-center section-container">
        <div className="neo-card p-16 bg-primary inline-block">
          <h1 className="text-9xl font-black mb-4" style={{
            textShadow: '6px 6px 0 #000'
          }}>
            404
          </h1>
          <h2 className="text-4xl font-black uppercase mb-6">
            Page Not Found
          </h2>
          <p className="text-xl font-bold mb-8">
            Oops! The page you're looking for doesn't exist.
          </p>
          <Link 
            to="/" 
            className="button-primary inline-flex items-center gap-2"
          >
            <Home className="w-5 h-5" />
            Go Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
